// src/features/payment/hooks/usePaymentCalculations.ts
import { useMemo } from "react";
import { Product } from "../types/payment";
import { LedgerDetails } from "src/shared/services/interfacev2";

export const usePaymentCalculations = (products: Product[], customer: LedgerDetails | null, showBalance: boolean, receivedAmount: number) => {
  return useMemo(() => {
    const orderAmount = products.reduce((sum, item) => sum + parseFloat(item.orderAmount), 0);

    const discount = products.reduce((sum, item) => sum + parseFloat(item.discount || "0"), 0);
    const deliveryFee = products.length > 0 ? Number(products[0].deliveryFee || 0) : 0;

    const finalAmount = orderAmount - discount + deliveryFee;
    const outstandingBalance = (customer?.totalOutstandingBalance || "0");
    const totalPayable = showBalance ? finalAmount + Number(outstandingBalance) : finalAmount;
    const remainingAmount = Math.max(totalPayable - receivedAmount, 0);

    return {
      orderAmount,
      discount,
      deliveryFee,
      finalAmount,
      outstandingBalance,
      totalPayable,
      remainingAmount,
    };
  }, [products, customer, showBalance, receivedAmount]);
};
